import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, CircularProgress, Alert } from '@mui/material';
import axios from 'axios';
import config from '../../config';
import MiPlanCard from '../../components/suscripcion/MiPlanCard';
import PlanesComparativa from '../../components/suscripcion/PlanesComparativa';

export default function MiPlan() {
  const [miPlan, setMiPlan] = useState(null);
  const [planes, setPlanes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPlanes, setShowPlanes] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [planRes, planesRes] = await Promise.all([
        axios.get(`${config.API_BASE_URL}/api/v1/suscripciones/mi-plan`),
        axios.get(`${config.API_BASE_URL}/api/v1/suscripciones/planes`),
      ]);
      if (planRes.data?.success) setMiPlan(planRes.data.data);
      if (planesRes.data?.success) setPlanes(planesRes.data.data);

      // Mostrar planes automáticamente si venció
      if (planRes.data?.data?.necesita_upgrade) setShowPlanes(true);
    } catch (e) {
      setError('Error al cargar la información del plan');
    } finally {
      setLoading(false);
    }
  };

  const handleSelectPlan = async (idPlan, tipoPeriodo) => {
    setCheckoutLoading(true);
    setError('');
    try {
      const res = await axios.post(`${config.API_BASE_URL}/api/v1/suscripciones/checkout`, {
        id_plan: idPlan,
        tipo_periodo: tipoPeriodo,
      });

      if (res.data?.success) {
        if (res.data.tipo === 'contacto') {
          window.open(res.data.whatsapp, '_blank');
        } else {
          // Redirigir a MercadoPago
          const url = process.env.NODE_ENV === 'production'
            ? res.data.checkout_url
            : res.data.sandbox_url || res.data.checkout_url;
          window.location.href = url;
        }
      }
    } catch (e) {
      setError(e.response?.data?.error || 'Error al iniciar el pago');
    } finally {
      setCheckoutLoading(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" fontWeight={800} color="#1E2783" gutterBottom>
        Mi Plan
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Gestiona tu suscripción y consulta el consumo de tu empresa
      </Typography>

      {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}

      {checkoutLoading && (
        <Alert severity="info" sx={{ mb: 3 }}>Preparando checkout con MercadoPago...</Alert>
      )}

      {/* Card del plan actual */}
      <Box sx={{ maxWidth: 500, mb: 4 }}>
        <MiPlanCard data={miPlan} onUpgrade={() => setShowPlanes(true)} />
      </Box>

      {/* Comparativa de planes */}
      {showPlanes && (
        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" fontWeight={700} color="#1E2783" textAlign="center" gutterBottom>
            Elige el plan ideal para tu negocio
          </Typography>
          <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ mb: 4 }}>
            Todos los planes incluyen GPS en tiempo real y soporte técnico
          </Typography>
          <PlanesComparativa
            planes={planes}
            planActual={miPlan?.plan?.codigo}
            onSelectPlan={handleSelectPlan}
          />
        </Box>
      )}
    </Container>
  );
}
